export default __webpack_public_path__ + "static/media/foto.05521cd0.svg";